// This is in its own file to ease mocking of it in tests without mocking the other utilities.
const loadScript = url => new Promise(resolve => {
  const headerScript = document.createElement("script");
  headerScript.src = url;
  headerScript.async = true;
  headerScript.onload = () => resolve();
  document.querySelector("head").appendChild(headerScript);
});

export { loadScript };
//# sourceMappingURL=load-script.js.map
